import { Component, h } from 'preact'
import InputGroup from '../../ui-components/InputGroup'
import getWithInMemoryCache from '../../../utils/getWithInMemoryCache'
import QuickLink from '../../quick-links/QuickLink'
import EditKnowledgeBase from './EditKnowledgeBase'
import Hover from '../../hover/Hover'
import Panel from '../../panel'

export interface ParentCategory {
  id: number
  title: 'string'
  url: 'string'
  description: 'string'
  thumbnailUrl: 'string'
  heroImageUrl: 'string'
  subforums: Array<Category>
}

interface Category extends Exclude<ParentCategory, 'subforums'> {
  type: 'knowledge_base' | 'community'
  showDescriptionOnHomepage: boolean
  topicCount: number
  replyCount: number
}

export interface KnowledgeBaseResponse {
  categoryGroups: Array<ParentCategory>
}

interface Props {
  title: string
  skipLoading?: boolean
  controlUrl?: string
  onChange: (state: {title: string}) => void
}

interface State {
  parentCategories: Array<ParentCategory>
  title: string
}

export class KnowledgeBaseHomepageManager extends Component<Props, State> {
  constructor (props: Props) {
    super()
    this.state = {
      title: props.title,
      parentCategories: []
    }
  }

  async componentDidMount () {
    if (this.props.skipLoading) return
    const res = await getWithInMemoryCache('/site/knowledgeBase', {})
    this.setState({ parentCategories: res.categoryGroups })
  }

  onChangeTitle (newTitle: string) {
    this.setState({ title: newTitle })
    this.props.onChange({ title: this.state.title })
  }

  render (props: Props, state: State) {
    const fallbackContent = props.skipLoading
      ? null
      : <p>There is no knowledge base category available yet. Start by <a href='/platform/knowledge-base'>adding knowledge base category</a>.</p>

    return (
        <div>
          <InputGroup
            title='Title'
            type='text'
            onChange={(e: ChangeEvent) => { this.onChangeTitle(e.target.value) }}
            value={state.title} />
          {
            state.parentCategories.length ? (
              <ul className='quicklink__container--knowledgeBase'>
                {
                  state.parentCategories.map((item, idx) => {
                    return <Hover key={item.id} hoverComponent={<EditKnowledgeBase key={'hover_'+item.id} link={`/platform/knowledge-base/edit?id=${item.id}`} />}>
                      <QuickLink {...props} item={item} idx={idx} key={'link_'+item.id} isKnowledgeBase isVisibleDesktop/>
                    </Hover>
                  }
                                      )
                }
              </ul>
            ) : fallbackContent
          }
        </div>
    )
  }
}

interface PanelProps extends Props {
  dragHandle: JSX.Element
  switcher: JSX.Element
}

const KnowledgeBasePanel = (props: PanelProps) => {
  return <Panel
      collapsible
      customClass='homepage-widget'
      title={<div className='panel-title-with-switch'>
        <div className='homepage-reorderable-panel-title'>
          { props.dragHandle }
          <span>Knowledge Base</span>
        </div>
        { props.switcher }
          </div>
    }>
    <KnowledgeBaseHomepageManager {...props} />
  </Panel>
}

export default KnowledgeBasePanel
